export default __webpack_public_path__ + "static/image7-351fd561822d6c0e68fdc99c665e4c13.jpg";